import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";
import { isMoEmbedded } from "./embed";

// Marks the chat read when its turn finishes WHILE the operator is actively looking at it — so a reply
// (or question) they just watched land in the open transcript doesn't leave a stuck unread dot.
//
// Deliberately narrow: it fires only on turn completion (never on tab-refocus, hover, or prefetch), and
// only when this chat is the open, visible, non-history panel. A chat the operator isn't looking at
// keeps its dot. Marking is a POST (#read), so Turbo's link prefetch can't trigger it.
export default class extends Controller {
  static values = { url: String };

  onThinkingEnd() {
    // Defer a tick: a cable reconnect removes and immediately re-appends the spinner (end→start), and
    // mid-turn tool rounds do the same. Re-checking next tick lets a re-appended spinner cancel this.
    setTimeout(() => this.#markReadIfActivelyViewed(), 0);
  }

  #markReadIfActivelyViewed() {
    if (!this.hasUrlValue) return;
    if (document.getElementById("massimo-thinking")) return; // still generating / mid tool round
    if (document.visibilityState !== "visible") return; // tab hidden — they're not looking
    if (!this.#panelOpen()) return; // docked panel closed (transcript stays mounted when closed)
    if (this.element.closest("[data-active-panel='history']")) return; // showing history, not this chat
    // responseKind turbo-stream so the nav-badge refresh #read returns clears the nav dot on this page.
    post(this.urlValue, { responseKind: "turbo-stream" });
  }

  #panelOpen() {
    if (isMoEmbedded()) return true; // the embed has no docked-panel toggle; it's always "open"
    return Boolean(document.getElementById("massimo-chat-toggle")?.checked);
  }
}
